import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable, catchError, map, of, throwError } from 'rxjs';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { UserManager } from 'src/app/core/services/user-manager';
import { Router } from '@angular/router';
import { PdaAuthService } from './Service/pda-auth.service';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import { environment } from 'src/environments/environment';
import { PdaDataStore } from '../store/pda-store';
import { SectionsServiceTsService } from './Service/sections.service.ts.service';
import { PdaConfigurationService } from './Service/pda-config.service';

@Injectable()
export class PdaInterceptor implements HttpInterceptor {

  private readonly GENERIC_ERROR = "L'operazione non è andata a buon fine";

  constructor(
    private modalNotifyService: ModalNotifyService,
    private userManager: UserManager,
    private router: Router,
    private authPda: PdaAuthService,
    private dialog: DialogService,
    private sectionService: SectionsServiceTsService,
    private pdaConfig: PdaConfigurationService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.handlePipe(request, next);
  }

  private handlePipe(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((err) => {
        let errorMessage = !!err.error.error ? err.error.error : (!!err.error.errorMessage ? err.error.errorMessage : err.error);
        if(req.url.includes(this.pdaConfig.getBaseUrl())) {
          this.showDynamicErrorModal("Non è stato possibile connettersi a PDA");
        }
        if(!errorMessage.includes("CSRF") && (req.url.includes('processotelematico') || errorMessage.includes("PST"))) {
          this.mapErrorCodeToMessage(req, err, errorMessage);
        }
        //return of(err);
        return throwError(() => err);
      })
    )
  }

   private mapErrorCodeToMessage(req: HttpRequest<any>, err, errorMessage) {
    switch (err.status) {
      case 401:
        // this.retry(req, next);
        this.pdaErrorHandler("Token invalido o scaduto",req,true);
        break;
      case 403:
        // this.retry(req, next);
        this.pdaErrorHandler("Accesso ai dati non autorizzato",req,false);
        break;
      case 404:
        if(req.url.includes('auth') && req.method == 'GET'){
          this.removePdaData();
        }
        else if(req.url.includes('datiGenerali') && req.method == "POST"){
          this.pdaErrorHandler("Non sono presenti dati per questo fascicolo sul Processo Telematico.",req,false);
        }
        break;
      case 500:
        if(errorMessage?.includes("codice registro Pct")){
            this.pdaMissingRegistryHandler(req, err);
            break;
          }
          if(this.handleServiceError(errorMessage, req, '500')){
            break;
          }
          if(!!errorMessage && errorMessage !== 'PdaException'){
            this.pdaErrorHandler(errorMessage, req, false);
          } else {
            this.pdaErrorHandler(this.GENERIC_ERROR, req, false);
          }
        break;
      case 503:
        this.pdaErrorHandler("Il servizio è temporaneamente non disponibile. Si prega di riprovare più tardi",req,false);
        break;
      default:
        if (this.handleServiceError(errorMessage, req, 'default')) {
            break;
          }
          if (err?.error?.length > 0) {
            this.pdaErrorHandler(err.error, req, false);
          } else {
            this.pdaErrorHandler(this.GENERIC_ERROR, req, false);
          }
        break;
    }
  }

  private buildServiceMessage(
    prefix: 'MS' | 'PST',
    context: '500' | 'default'
    ): string {
    const timeLabel =
      context === '500'
        ? 'Al momento'
        : 'In questo momento';

    const actionLabel =
      prefix === 'MS'
        ? "si consiglia"
        : "si prega";

    return `${timeLabel} non è possibile completare l'operazione, ${actionLabel} di riprovare piu' tardi.`;
  }

  private handleServiceError(
    errorMessage: string,
    req: any,
    context: '500' | 'default'
    ): boolean {
    if (errorMessage?.startsWith('MS:')) {
      this.pdaErrorHandler(
        this.buildServiceMessage('MS', context),
        req,
        false
      );
      return true;
    }

    if (errorMessage?.startsWith('PST:')) {
      this.pdaErrorHandler(
        this.buildServiceMessage('PST', context),
        req,
        false
      );
      return true;
    }
    return false;
  }


  pdaErrorHandler(message: string, req: HttpRequest<any>, doLogout: boolean){
    this.showDynamicErrorModal(message);
    //Per evitare loop con errori su chiamata di DELETE
    if(doLogout && !(req.url.includes("auth") && req.method == "DELETE")) {
      this.authPda.onLogoutUserPda(true);
      this.authPda.setIsLogged(false);
    }
  }

  pdaMissingRegistryHandler(req: HttpRequest<any>, err: any){

    if(err.error?.fascicoloPct?.idFascicoloPct){
      let errorPct = err.error.fascicoloPct;
      PdaDataStore.cleanupStore();
      this.sectionService.getInfoFascicoloPct(err.error.fascicoloPct.idFascicoloPct).subscribe(
        pctInfo => {
          PdaDataStore.getInstance().pctInfoFascicolo = pctInfo;
        }
      );
    }
    this.pdaErrorHandler("Impossibile aggiornare le informazioni del Processo Telematico: codice di registro mancante. Aggiungere il codice registro in Sezione Dati Generali.",req,false);
  }

  removePdaData(){
    console.log("removing pda data");
    this.authPda.setIsLogged(false);
    this.authPda.removePdaToken();
    this.authPda.removePdaInfos();
  }

  retry(req, next) {
    req['cycle'] = req['cycle'] ? req['cycle'] + 1 : 1;
    if (req['cycle'] < 3) {
      return this.handlePipe(req, next);
    }
  }


  private showDynamicErrorModal(message) {
    this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: message,
          hideButtons: true,
          confirmButton: true
        },
        style: {
          width: '30%',
          zIndex: '9999999 !important'
        },
        title: 'Accesso al portale PDA',
      }
    });
  }
}
